export const API_KEY = 'e36c39cf3e4433cbbdb75bad088f440d';
export const PATH_BASE = 'https://api.themoviedb.org/3';

export const PATH_SEARCH = '/search';

export const PATH_MOVIE = '/movie';
export const PATH_DISCOVER = '/discover';
export const PATH_POPULAR = '/popular';
export const PATH_TOP_RATED = '/top_rated';
export const PATH_UPCOMING = '/upcoming';

export const DEFAULT_PAGE = 1;
export const PATH_PAGE = 'page='



// WEBPACK FOOTER //
// ./src/api/index.js